const TRANSITION_DURATION = 600;
function cleanPath(path) {
  return path.replace(/\/+$/, "") || "/";
}

function getLabel(pathname) {
  const parts = cleanPath(pathname).split("/").filter(Boolean);
  if (!parts.length) return "Home";

  return parts[parts.length - 1]
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

function addTransitionAttributes() {
  const host = window.location.hostname;

  document.querySelectorAll("a[href]").forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) return;

    const hasTransitionAttribute = Array.from(link.attributes).some((attribute) =>
      attribute.name.startsWith("data-vt-")
    );
    if (hasTransitionAttribute) return;

    try {
      const url = new URL(href, window.location.origin);
      if (url.hostname !== host || href === "#") return;

      const path = cleanPath(url.pathname);
      link.setAttribute("data-vt-label", getLabel(path));
    } catch (error) {
      return;
    }
  });
}

function initViewTransitions() {
  const overlay = document.createElement("div");
  overlay.className = "vt-overlay";

  const label = document.createElement("span");
  label.className = "vt-overlay__label";
  overlay.appendChild(label);

  const image = document.createElement("img");
  image.className = "vt-overlay__image";
  overlay.appendChild(image);

  document.body.appendChild(overlay);

  const isForwardNavigation = window.sessionStorage.getItem("vt-forward");
  window.sessionStorage.removeItem("vt-forward");

  if (!isForwardNavigation) {
    const disableNativeTransition = document.createElement("style");
    disableNativeTransition.textContent =
      "::view-transition-old(root), ::view-transition-new(root) { animation: none !important; }";
    document.head.appendChild(disableNativeTransition);
  }

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;

    overlay.removeAttribute("style");
    overlay.style.animation = "none";
    overlay.style.transform = "scaleY(0)";
    overlay.classList.remove("is-active");
    label.textContent = "";
    label.style.display = "none";
    image.src = "";
    image.style.display = "none";
  });

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");
    if (!link) return;
    if (link.hostname !== window.location.hostname) return;
    if (link.getAttribute("href") === "#") return;
    if (link.pathname === window.location.pathname && link.hash) return;
    if (link.hasAttribute("data-vt-ignore")) return;
    if (link.target === "_blank") return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;

    event.preventDefault();

    const source = link.getAttribute("data-vt-image") || "";
    const text = source ? "" : link.getAttribute("data-vt-label") || "";

    label.textContent = text;
    label.style.display = text ? "" : "none";
    image.src = source;
    image.style.display = source ? "" : "none";

    overlay.removeAttribute("style");

    const styles = link.getAttribute("data-vt-style");
    if (styles) {
      styles.split(";").forEach((pair) => {
        const parts = pair.split(":");
        if (parts.length === 2) {
          overlay.style.setProperty(parts[0].trim(), parts[1].trim());
        }
      });
    }

    overlay.classList.add("is-active");
    window.sessionStorage.setItem("vt-forward", "1");

    window.setTimeout(() => {
      window.location.href = link.href;
    }, TRANSITION_DURATION);
  });

  addTransitionAttributes();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initViewTransitions);
} else {
  initViewTransitions();
}
